import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../contexts/auth/Context";
import {
  NOTIFICATION_UNREAD_COUNT_QUERY_KEY,
  PLATFORM_NOTIFICATION_UNREAD_COUNT_QUERY_KEY,
} from "../../query/keys";
import { getUnreadCountRequest } from "../requests/notification/notification";
import { getPlatformUnreadCountRequest } from "../requests/notification/platformNotification";
import { isSuperAdminRole } from "../../contexts/auth/utils";

export const useUnreadCount = () => {
  const { token } = useAuth();
  const isPlatform = isSuperAdminRole(token);

  return useQuery({
    queryKey: isPlatform
      ? PLATFORM_NOTIFICATION_UNREAD_COUNT_QUERY_KEY
      : NOTIFICATION_UNREAD_COUNT_QUERY_KEY,
    queryFn: () =>
      isPlatform
        ? getPlatformUnreadCountRequest(token!)
        : getUnreadCountRequest(token!),
    enabled: !!token,
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
    refetchOnMount: true,
  });
};
